var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"knet-payment-page"},[_c('div',{staticClass:"payment-message"},[_vm._v(" "+_vm._s(_vm.$t("payment-transaction-is-processed"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }